import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import styles from "./videochat.module.scss"
import VideoSmall from './videoSmall'
import Videofooter from './videofooter'
import store from '../../../store/redux-store/root_store';
import _ from 'lodash';
import CloseCaptionCommon from '../../joinMeetingScreen/closeCaption/closecaption';
import { useSelector } from 'react-redux';
import { Popover } from 'antd';
import { Joining } from '../../../joining';
import Lottie from 'lottie-react';
import { formatTime, updateFullScreen, updateVirtualBGRedux,toDataUrl, updateBGV } from '../../../base/video_common';
import loadersimg from "../../../styles/images//connecting.json";
import { videoCallService } from '../../../base/service/videoCallService';
import axios from 'axios';
import { GetItemFromStorage } from '../../../custom_hooks/useStorage';
import { LocalStorage } from '../../../custom_hooks/localStorageKeys';
import { VirtualBGRender } from '../../joinMeetingScreen/virtualBGRrender';
import { BackgroundConfig } from '../../virtualBackground/core/helpers/backgroundHelper';
import useTFLite, { TFLite } from '../../virtualBackground/core/hooks/useTFLite';
import { BodyPix } from '@tensorflow-models/body-pix';
import { PostProcessingConfig } from '../../virtualBackground/core/helpers/postProcessingHelper';
import { SegmentationConfig } from '../../virtualBackground/core/helpers/segmentationHelper';
import { VirtualBGModel } from '../../virtualBackground/core/helpers/VBModel';
import { initialStateModel } from '../../../base/models/meetModal';
import { toast } from '../../../annotation';
import VideoTransfer from '../../../shared/widges/agentcall/videoTransfer';
import { meetActionTypes } from '../../../base/action/action';
import useBodyPix from '../../virtualBackground/core/hooks/useBodyPix';
type VideoCenterProps = {
  dataclass: any;
}

export default function VideoCenter({ dataclass }: VideoCenterProps) {

  const { activeParticipantList, currdeviceinfo, connstatus, elapsedTime,vmTransfer,vmTransferDropdown,vmSettings } = store.getState().meetingReducer;
  const { ccBtns } = store.getState().closeCaption;
  const closeCaption: any = useSelector((state: any) => state.closeCaption);
  let stored_Video = store.getState().storeVideo;
  let activeSpeaker = store.getState().meetingReducer;
  let activeSpeakerState: any = activeSpeaker || {}
  let participantVideo: any = useRef(null);
  let remVideo: any = useRef(null);
  const [switchStream, setSwitchStream] = useState(false);
  let remotedev: any = activeParticipantList.filter((ele: any) => { return ele.conId !== currdeviceinfo.conId })
  const canvasEL: any = document.getElementById('canvas123');
  const gl = canvasEL.getContext('webgl2') || null;
  const getRes = new VirtualBGModel(gl ? 'mlkit' : 'bodyPix', true, "webgl");  const videoMeetState: initialStateModel = useSelector((state: initialStateModel) => state);
  const virtualBGState: { image: any, imgIndex: number, viewMode: string } =
    useSelector((state: initialStateModel) => state.VirtualBG);

  const backgroundConfig: BackgroundConfig =     { "type": "image", "url": (!_.isEmpty(vmSettings) && vmSettings.virtualBackground!== null && vmSettings.virtualBackgroundId !== null && vmSettings.isVirtualBackground !==0 ) ?  vmSettings.virtualBackground : ""};
  
  const [
    segmentationConfig,
    setSegmentationConfig
  ] = useState<SegmentationConfig>(getRes.getResolutionDetails());
  
  const bodyPix = useBodyPix();
  // const { tflite } = useTFLite(segmentationConfig);

  const [
    postProcessingConfig,
    setPostProcessingConfig
  ] = useState<PostProcessingConfig>({
    smoothSegmentationMask: false,
    jointBilateralFilter: { sigmaSpace: 5.6, sigmaColor: 0.3 },
    coverage: [0.5, 0.75],
    lightWrapping: 0.1,
    blendMode: 'screen'
  });
  useEffect(() => {
    let timerIntervalTransfer: any;

    if (vmTransfer) {
      timerIntervalTransfer = setInterval(() => {
        let {vmTransferStartTime}:any=store.getState().meetingReducer;
        const now = new Date();
        store.dispatch({
          type:meetActionTypes.VM_TRANSFER_TIME,
         payload:{
          vmTransferTimer:now.getTime()-vmTransferStartTime,
          vmTransferStartTime:vmTransferStartTime
        }
        })
      }, 1000);
    }
    else{
      clearInterval(timerIntervalTransfer);
    }
    return()=>{
      clearInterval(timerIntervalTransfer);
    }
  }, [JSON.stringify(closeCaption),vmTransfer])

  useEffect(() => {
    if (currdeviceinfo.status === "joined") {
      let videoData: any = _.find(stored_Video.participantList, { participants: currdeviceinfo.conId });
      if (videoData !== undefined && videoData.stream !== '') {
        if ((participantVideo.current.srcObject === null)
          || (participantVideo.current.srcObject.id !== videoData.stream.id)) {
          participantVideo.current.srcObject = videoData.stream;
        }
      }
    }
    if (remotedev[0]?.status === "joined") {
      let videoData: any = _.find(stored_Video.participantList, { participants: remotedev[0]?.conId });
      if (videoData !== undefined && videoData.stream !== '') {
        if ((remVideo.current.srcObject === null)
          || (remVideo.current.srcObject.id !== videoData.stream.id)) {
          remVideo.current.srcObject = videoData.stream;
        }
      }
    }
if(!_.isEmpty(vmSettings) && vmSettings.virtualBackground!== null && vmSettings.virtualBackgroundId !== null && vmSettings.isVirtualBackground !==0 ){setVirtualBGUpdates(vmSettings.virtualBackground,vmSettings.virtualBackgroundId);}
  }, [activeSpeakerState, activeParticipantList, stored_Video, stored_Video.participantList.length, activeParticipantList.length,JSON.stringify(currdeviceinfo)])


  const setVirtualBGUpdates = async(img:any,index:number) => {
    if (gl) {
      await toDataUrl(img, function(myBase64: any) {
        console.log("myBase64myBase64",myBase64);
        updateVirtualBGRedux(myBase64, index);
      });
    } else {
      toast("Your Device Does not support WebGL2 update your Graphic driver");
    }
  };
  const playbackInfo = {
    htmlElement: participantVideo.current,
    width: participantVideo.current?.videoWidth,
    height: participantVideo.current?.videoHeight
  };

  // useEffect(()=>{
  //   if (tflite && bodyPix) {
  //     updateBGV(tflite, bodyPix);
  //   }
  // },[tflite,bodyPix])

  const switchVideo = () => {
    setSwitchStream(!switchStream)
  }

  const recordParticipant = (action: any) => {

    if (action === "pause") {
     videoCallService.recordingAction("pause", currdeviceinfo.conId);

   }
   else if (action === "resume") {
     videoCallService.recordingAction("resume", currdeviceinfo.conId);

   }
   else {
     videoCallService.recordingAction("stop", currdeviceinfo.conId);
   }
 }

  const fullScreen = () => {
    const { fullScreenAgent } = store.getState().meetingReducer;
    updateFullScreen(!fullScreenAgent)
  }
  return (
    <div className={dataclass ? styles.videoCharAreafull : styles.videoCharArea}>

      {connstatus !== "connected" && <div className="ccloaderagent"><Lottie className="lottieimg" animationData={loadersimg} />Joining...</div>}
      {ccBtns && <CloseCaptionCommon type={"agentcaption"} />}
      <Popover
        content={""}
        overlayClassName={"recordingpopover"}
        trigger="hover"
      >


      </Popover>
      <div className={styles.videotopbar}>
        <div className={styles.lefts}>
          <ul>
            <li>



              {!remotedev[0]?.mute ? <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="32" height="32" rx="8" fill="black" fill-opacity="0.2" />
                <g clip-path="url(#clip0_3269_55899)">
                  <path d="M16 19.2655C17.7148 19.2655 19.1104 17.87 19.1104 16.1551V9.58475C19.1104 7.86995 17.7149 6.47485 16 6.47485C14.2851 6.47485 12.8901 7.86985 12.8901 9.58475V16.1551C12.8901 17.8699 14.2851 19.2655 16 19.2655ZM14.3901 9.58475C14.3901 8.69705 15.1123 7.97485 16 7.97485C16.8882 7.97485 17.6104 8.69705 17.6104 9.58475V16.1551C17.6104 17.0433 16.8882 17.7655 16 17.7655C15.1123 17.7655 14.3901 17.0433 14.3901 16.1551V9.58475Z" fill="#000" />
                  <path d="M22.4404 16.055V13.0447C22.4404 12.6306 22.1045 12.2947 21.6904 12.2947C21.2763 12.2947 20.9404 12.6306 20.9404 13.0447V16.055C20.9404 18.6629 18.7246 20.785 16 20.785C13.2754 20.785 11.0601 18.6629 11.0601 16.055V13.0447C11.0601 12.6306 10.7242 12.2947 10.3101 12.2947C9.89596 12.2947 9.56006 12.6306 9.56006 13.0447V16.055C9.56006 19.2443 12.0518 21.8779 15.25 22.239V24.2244H11.8301C11.4712 24.2244 11.1802 24.5154 11.1802 24.8748C11.1802 25.2342 11.4712 25.5252 11.8301 25.5252H20.1699C20.5293 25.5252 20.8203 25.2342 20.8203 24.8748C20.8203 24.5154 20.5293 24.2244 20.1699 24.2244H16.75V22.239C19.9483 21.8779 22.4404 19.2442 22.4404 16.055Z" fill="#000" />
                </g>
                <defs>
                  <clipPath id="clip0_3269_55899">
                    <rect width="24" height="24" fill="white" transform="translate(4 4)" />
                  </clipPath>
                </defs>
              </svg> :


               
<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="8" fill="black" fill-opacity="0.2"/>
<g clip-path="url(#clip0_3287_79401)">
<path d="M14.39 11.965L17.61 15.195L18.36 15.955L19.07 16.665C19.1 16.495 19.11 16.325 19.11 16.155V9.58498C19.11 7.86498 17.71 6.47498 16 6.47498C14.28 6.47498 12.89 7.86498 12.89 9.58498V10.455L13.64 11.205L14.39 11.965Z" fill="#DE003D"/>
<path d="M22.44 16.055V13.045C22.44 12.625 22.1 12.295 21.69 12.295C21.28 12.295 20.94 12.625 20.94 13.045V16.055C20.94 16.775 20.77 17.455 20.46 18.065L21.56 19.175C22.12 18.255 22.44 17.195 22.44 16.055Z" fill="#DE003D"/>
<path d="M24.68 24.775C24.53 24.925 24.34 24.995 24.15 24.995C23.96 24.995 23.77 24.925 23.62 24.775L19.87 21.015C18.98 21.675 17.92 22.115 16.75 22.245V24.225H20.18C20.54 24.225 20.83 24.515 20.83 24.875C20.83 25.235 20.54 25.525 20.18 25.525H11.83C11.47 25.525 11.18 25.235 11.18 24.875C11.18 24.515 11.47 24.225 11.83 24.225H15.25V22.245C12.04 21.885 9.55004 19.245 9.55004 16.055V13.045C9.55004 12.625 9.89004 12.295 10.3 12.295C10.71 12.295 11.05 12.625 11.05 13.045V16.055C11.05 18.665 13.27 20.785 16 20.785C17.04 20.785 18.01 20.475 18.81 19.945L17.65 18.775C17.17 19.085 16.61 19.255 16 19.255C14.28 19.255 12.89 17.865 12.89 16.155V13.995L7.32004 8.40498C7.03004 8.11498 7.03004 7.63498 7.32004 7.34498C7.61004 7.05498 8.09004 7.05498 8.38004 7.34498L24.68 23.715C24.97 24.005 24.97 24.485 24.68 24.775Z" fill="#DE003D"/>
</g>
<defs>
<clipPath id="clip0_3287_79401">
<rect width="24" height="24" fill="white" transform="translate(4 4)"/>
</clipPath>
</defs>
</svg>

              }
            </li>
            <li onClick={fullScreen}>

              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="32" height="32" rx="6" fill="black" fill-opacity="0.2" />
                <g clip-path="url(#clip0_3269_55903)">
                  <path d="M23.7256 6.0127H19.9258C19.5117 6.0127 19.1758 6.3486 19.1758 6.7627C19.1758 7.1768 19.5117 7.5127 19.9258 7.5127H23.4146L18.2959 12.6318C18.0029 12.9248 18.0029 13.3994 18.2959 13.6923C18.4424 13.8388 18.6343 13.912 18.8262 13.912C19.0181 13.912 19.21 13.8388 19.3565 13.6923L24.4756 8.5727V12.0624C24.4756 12.4765 24.8115 12.8124 25.2256 12.8124C25.6397 12.8124 25.9756 12.4765 25.9756 12.0624V8.2626C25.9756 7.0224 24.9663 6.0127 23.7256 6.0127Z" fill="#F0F1F2" />
                  <path d="M12.643 18.3076L7.52393 23.4272V19.9375C7.52393 19.5234 7.18803 19.1875 6.77393 19.1875C6.35983 19.1875 6.02393 19.5234 6.02393 19.9375V23.7373C6.02393 24.9775 7.03323 25.9873 8.27393 25.9873H12.0737C12.4878 25.9873 12.8237 25.6514 12.8237 25.2373C12.8237 24.8232 12.4878 24.4873 12.0737 24.4873H8.58493L13.7036 19.3682C13.9966 19.0752 13.9966 18.6006 13.7036 18.3077C13.4106 18.0148 12.9359 18.0146 12.643 18.3076Z" fill="#F0F1F2" />
                </g>
                <defs>
                  <clipPath id="clip0_3269_55903">
                    <rect width="24" height="24" fill="white" transform="translate(4 4)" />
                  </clipPath>
                </defs>
              </svg>
            </li>
            {currdeviceinfo.recordingStatus !== "stop" && <li className={styles.recmain}>
              <div className={styles.rectop}>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M6.99967 0.333984C3.31967 0.333984 0.333008 3.32065 0.333008 7.00065C0.333008 10.6807 3.31967 13.6673 6.99967 13.6673C10.6797 13.6673 13.6663 10.6807 13.6663 7.00065C13.6663 3.32065 10.6797 0.333984 6.99967 0.333984ZM6.99967 9.67398C5.52634 9.67398 4.33301 8.48065 4.33301 7.00732C4.33301 5.53398 5.52634 4.34065 6.99967 4.34065C8.47301 4.34065 9.66634 5.53398 9.66634 7.00732C9.66634 8.48065 8.47301 9.67398 6.99967 9.67398Z" fill="#DE003D" />
                </svg>
                Rec
                {/* <div>{formatTime(elapsedTime)}</div> */}
                {currdeviceinfo.recordingStatus === "pause" && 
                 <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none" onClick={()=>recordParticipant("resume")}>
                  <path d="M9.02623 4.61023L5.80091 2.75101L2.57559 0.891783C2.31569 0.745178 2.04247 0.671875 1.77592 0.671875C0.936269 0.671875 0.169922 1.34493 0.169922 2.27787V9.72144C0.169922 10.661 0.936269 11.3274 1.77592 11.3274C2.04247 11.3274 2.31569 11.2608 2.57559 11.1075L5.80091 9.2483L9.02623 7.38908C10.0991 6.76933 10.0991 5.22331 9.02623 4.61023Z" fill="white" />
                </svg>}
                {(currdeviceinfo.recordingStatus === "start" || currdeviceinfo.recordingStatus === "resume") &&
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={()=>recordParticipant("pause")}>
                  <path d="M6.99983 1.33553C10.1252 1.33553 12.6641 3.8745 12.6641 6.9999C12.6641 10.1253 10.1252 12.6643 6.99983 12.6643C3.87446 12.6643 1.33552 10.1186 1.33552 6.9999C1.33552 3.88116 3.87446 1.33553 6.99983 1.33553ZM6.99983 0.335938C3.3147 0.335938 0.335938 3.31473 0.335938 6.9999C0.335938 10.6851 3.32136 13.6639 6.99983 13.6639C10.6783 13.6639 13.6637 10.6784 13.6637 6.9999C13.6637 3.32139 10.6783 0.335938 6.99983 0.335938Z" fill="white"/>
                  <path d="M5.00066 5.00071V8.99242C5.00066 9.36047 5.299 9.65881 5.66705 9.65881C6.0351 9.65881 6.33344 9.36047 6.33344 8.99242V5.00071C6.33344 4.63266 6.0351 4.33431 5.66705 4.33431C5.299 4.33431 5.00066 4.63266 5.00066 5.00071Z" fill="white"/>
                  <path d="M7.66622 5.00071V8.99242C7.66622 9.36047 7.96456 9.65881 8.33261 9.65881C8.70065 9.65881 8.99899 9.36047 8.99899 8.99242V5.00071C8.99899 4.63266 8.70065 4.33431 8.33261 4.33431C7.96456 4.33431 7.66622 4.63266 7.66622 5.00071Z" fill="white"/>
                  </svg>
                  
                }
                 <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" onClick={()=>recordParticipant("stop")}>
                  <path d="M6.99967 0.333984C3.31781 0.333984 0.333008 3.31872 0.333008 7.00065C0.333008 10.6826 3.31781 13.6673 6.99967 13.6673C10.6815 13.6673 13.6663 10.6826 13.6663 7.00065C13.6663 3.31872 10.6815 0.333984 6.99967 0.333984ZM6.99967 12.6673C3.87507 12.6673 1.33301 10.1253 1.33301 7.00065C1.33301 3.87598 3.87507 1.33398 6.99967 1.33398C10.1243 1.33398 12.6663 3.87598 12.6663 7.00065C12.6663 10.1253 10.1243 12.6673 6.99967 12.6673Z" fill="white" />
                  <path d="M8.83234 4.50132H5.16701C4.79882 4.50132 4.50034 4.79979 4.50034 5.16798V8.83332C4.50034 9.20151 4.79882 9.49998 5.16701 9.49998H8.83234C9.20053 9.49998 9.49901 9.20151 9.49901 8.83332V5.16798C9.49901 4.79979 9.20053 4.50132 8.83234 4.50132Z" fill="white" />
                </svg>
              </div>
            </li>}

          </ul>
        </div>
        <div  className={`${styles.rights} ${styles.positioncontainer}`} onClick={switchVideo}>
          <VideoSmall participantVideo={participantVideo} videoType={"agent"}/>
          <div className={styles.drpdwn}>
          {vmTransferDropdown && <VideoTransfer ></VideoTransfer>}

          </div>
        </div>
        {/* {currdeviceinfo &&
          participantVideo.current &&
          backgroundConfig &&
          playbackInfo.htmlElement &&
          playbackInfo.width &&
          tflite &&
          bodyPix &&
          postProcessingConfig &&
          segmentationConfig &&
          virtualBGState.image &&
          currdeviceinfo.video ? (
            <VirtualBGRender
              imgIndex={videoMeetState.VirtualBG.imgIndex}
              sourcePlayBack={playbackInfo}
              backgroundConfig={backgroundConfig}
              segmentationConfig={segmentationConfig}
              tflite={tflite}
              bodyPix={bodyPix}
              postProcessingConfig={postProcessingConfig}
              participant={currdeviceinfo}
              innerStyles={{
                position: "absolute",
                left: "0",
                width: "100%",
                zIndex: 0,
                top: "0px",
                height: "100%",
                transform:  "scale(-1, 1)"
              }}
            ></VirtualBGRender>
          ) : null} */}
      </div>
      {!remotedev[0]?.video && (
        <div className='novideoname'>
          <div className={styles.avatorrcontainer}>
          <div className="novideonametext">{remotedev[0]?.name?.toUpperCase().slice(0, 2)}</div>
          </div>
        </div>
      )}
      <video
        id={remotedev[0]?.conId}
        ref={remVideo}
        playsInline
        autoPlay
        preload={"auto"}
        style={{ display: !remotedev.video ? "block" : "none" }}
      // src='http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4'
      />
      <h4 className={styles.username}>{remotedev[0]?.name}</h4>
      <div>
      <Videofooter />

      </div>
    </div>
  )
}